import { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import './loadingScreen.scss';

let hasPlayedLoadingScreen = false;

export default function LoadingScreen({ isLoading }) {
  const [isAnimatingOut, setIsAnimatingOut] = useState(hasPlayedLoadingScreen);
  const [isUnmounted, setIsUnmounted] = useState(hasPlayedLoadingScreen);

  useEffect(() => {
    if (hasPlayedLoadingScreen) return;

    let startAnimTimer;
    let unmountTimer;

    if (!isLoading) {
      startAnimTimer = setTimeout(() => setIsAnimatingOut(true), 800);

      unmountTimer = setTimeout(() => {
        setIsUnmounted(true);
        hasPlayedLoadingScreen = true;
      }, 2000);
    }

    return () => {
      clearTimeout(startAnimTimer);
      clearTimeout(unmountTimer);
    };
  }, [isLoading]);

  if (isUnmounted) return null;

  return (
    <div className={`loading-screen-container ${isAnimatingOut ? 'animating-out' : ''}`}>
      <div className="loading-panel panel-left"></div>
      <div className="loading-panel panel-right"></div>

      <div className="loading-content">
        <Spinner animation="border" variant="dark" role="status" style={{ width: '3rem', height: '3rem' }}>
          <span className="visually-hidden">Cargando...</span>
        </Spinner>
        <p className="mt-3 text-dark fw-bold fs-5">Cargando...</p>
      </div>
    </div>
  );
}
